"use strict";

//polyfills
require("es6-shim");
var promiseFinally = require("promise.prototype.finally");
promiseFinally.shim();

if (typeof Promise === "undefined" || !Promise.prototype.finally) {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require("promise/lib/rejection-tracking").enable();
  window.Promise = require("promise/lib/es6-extensions.js");
}

// fetch() polyfill for making API calls.
require("whatwg-fetch");

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require("object-assign");

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === "test") {
  require("raf").polyfill(global);
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(stringBuscada, posicion) {
    posicion = posicion || 0;
    return this.indexOf(stringBuscada, posicion) === posicion;
  };
}

// IE does not support .includes() so I'm making my own:
if (!String.prototype.includes) {
  String.prototype.includes = function(needle) {
    return this.substring(needle) != -1;
  };
}

if (!Object.entries) {
  Object.entries = function(obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 612
// module chunks = 0